import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  theme?: 'light' | 'dark';
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items,
  className = '',
  theme = 'light',
}) => {
  const isDark = theme === 'dark';

  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center gap-1.5 text-xs font-mono overflow-x-auto py-1 ${className}`}
    >
      <Link
        to="/"
        className={`inline-flex items-center gap-1 transition-colors ${
          isDark ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-900'
        }`}
        title="Home"
      >
        <Home className="w-3.5 h-3.5" />
      </Link>

      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <React.Fragment key={idx}>
            <ChevronRight
              className={`w-3 h-3 shrink-0 ${
                isDark ? 'text-slate-600' : 'text-slate-400'
              }`}
            />
            {item.href && !isLast ? (
              <Link
                to={item.href}
                className={`truncate max-w-[140px] sm:max-w-none transition-colors ${
                  isDark ? 'text-slate-400 hover:text-brand-300' : 'text-slate-600 hover:text-brand-700'
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={`font-semibold truncate max-w-[160px] sm:max-w-none ${
                  isDark ? 'text-brand-400' : 'text-editorial-dark'
                }`}
                aria-current={isLast ? 'page' : undefined}
              >
                {item.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
